import React from 'react';

function ThuChiCongDoanPage() {
    return <h4>Trang đang trong quá trình phát triển</h4>;
}

export default ThuChiCongDoanPage;
